import { render, staticRenderFns } from "./base-home.vue?vue&type=template&id=ba4fe2d2&scoped=true&"
import script from "./base-home.vue?vue&type=script&lang=ts&"
export * from "./base-home.vue?vue&type=script&lang=ts&"
import style0 from "./base-home.vue?vue&type=style&index=0&id=ba4fe2d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4fe2d2",
  null
  
)

export default component.exports